/** Plain JSON object map: image id -> unlock key string. */
export function isValidKeyBundle(x: unknown): x is Record<string, string> {
  if (x === null || typeof x !== "object" || Array.isArray(x)) return false;
  return Object.entries(x as Record<string, unknown>).every(
    ([k, v]) => typeof k === "string" && typeof v === "string",
  );
}

export function parseKeyBundleJson(
  text: string,
): Record<string, string> | null {
  try {
    const parsed = JSON.parse(text) as unknown;
    if (!isValidKeyBundle(parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}
